import asyncComponent from '../component/asyncComponent'

export default [
    {
        name: "wx-bding-phone",
        route: "/wx-bding-phone",
        component: asyncComponent(() => import('../pages/wx-bding-phone')),
    },
    {
        name: "personal",
        route: "/user/personal",
        component: asyncComponent(() => import('../pages/user/personal')),
    },
]